import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginApi } from '../../services/api';
import { showMessage } from '../../utils/message';
import './Login.css';

const Login = () => {
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.username || !formData.password) {
      showMessage('请输入用户名和密码', 'error');
      return;
    }

    setLoading(true);
    try {
      console.log('开始登录请求...');
      const response = await loginApi(formData);
      
      if (response.status === 0) {
        // 登录成功，保存用户信息
        localStorage.setItem('userInfo', JSON.stringify(response.result));
        showMessage('登录成功', 'success');
        navigate('/dashboard');
      } else {
        // 这个分支理论上不会执行，因为checkStatus会抛出错误
        showMessage(response.message, 'error');
      }
    } catch (error) {
      console.error('登录失败:', error);
      
      // 检查是否是业务错误（来自后端的错误响应）
      if (error.isBusinessError) {
        // 业务错误，显示后端返回的错误消息
        showMessage(error.message, 'error');
      } else if (error.code === 'ERR_NETWORK') {
        // 网络错误
        showMessage('网络错误：无法连接到 localhost:8082，请确认后端服务已启动', 'error');
      } else if (error.message.includes('网络连接失败') || error.message.includes('无法连接到服务器')) {
        showMessage('网络连接失败，请检查后端服务是否启动在 localhost:8082', 'error');
      } else if (error.message.includes('跨域')) {
        showMessage('跨域请求被阻止，请检查后端CORS配置', 'error');
      } else {
        // 其他未知错误
        showMessage(error.message || '登录失败，请稍后重试', 'error');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>欢迎登录</h1>
          <p>请输入您的账号信息</p>
        </div>
        
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="username">用户名</label>
            <input
              type="text"
              id="username"
              name="username"
              value={formData.username}
              onChange={handleInputChange}
              placeholder="请输入用户名"
              disabled={loading}
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">密码</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleInputChange}
              placeholder="请输入密码"
              disabled={loading}
            />
          </div>
          
          <button 
            type="submit" 
            className={`login-btn ${loading ? 'loading' : ''}`}
            disabled={loading}
          >
            {loading ? '登录中...' : '登录'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;